import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { sanityClient } from '../client';
import { Circles, Rings } from 'react-loader-spinner';

const Skills = () => {
  const [skills, setSkills] = useState(null);
  useEffect(() => {
    sanityClient
      .fetch(`*[_type=="skills"]`)
      .then((data) => setSkills(data))
      .catch(console.error);
  }, []);
  if (!skills)
    return (
      <div className="flex  items-center justify-center ">
        <Circles height={30} width={30} color="#5bccf6" />
      </div>
    );
  return (
    <div className=" mb-20 relative flex flex-relative flex-col text-center md:text-left xl:flex-row max-w-[800px] mx-auto xl:px-10 min-h-screen justify-center items-center">
      <h3 className="absolute text-center mb-24 top-0 uppercase tracking-[20px] text-gray-500">
        My Skills
      </h3>
      <h3 className="absolute top-14 uppercase tracking-[3px] text-gray-500 text-[8px] md:text-sm">
        I Use These Libraries and Technologies for Website Developemt
      </h3>
      <div className="flex pt-28 sm:mt-0 flex-col">
        {skills.map((skill, index) => (
          <motion.div
            key={index}
            initial={{
              opacity: 0,
              x: index % 2 === 0 ? 200 : -200,
            }}
            transition={{ duration: 1.2 }}
            whileInView={{
              opacity: 1,
              x: 0,
            }}
            viewport={{ once: true }}
            className="space-y-4"
          >
            <h4 className="text-center tracking-[5px] font-bold">
              {skill?.heading}
            </h4>
            <div className=" w-full md:w-3/4 mx-auto  mt-4 flex  gap-6 p-4 justify-center flex-wrap gap-2 md:gap-5">
              {skill?.technologies.map((tech, index) => (
                <p className="skillTech" key={index}>
                  {tech}
                </p>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Skills;
